import { render, staticRenderFns } from "./DepositOrderDetails.vue?vue&type=template&id=ef68a65a&scoped=true"
import script from "./DepositOrderDetails.vue?vue&type=script&lang=js"
export * from "./DepositOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositOrderDetails.vue?vue&type=style&index=0&id=ef68a65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.23_vue-t_lre32xywqxiddeo252btsfuiei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68a65a",
  null
  
)

export default component.exports